<goab-table
  [attr.data-testid]="'entries-table-' + tab"
  width="100%"
  (onSort)="tableOnSort($event)"
>
  <thead>
    <tr>
      <th>
        <goab-table-sort-header
          [name]="'facilityName'"
          [direction]="sort().facilityName!"
        >
          <div class="header-container">
            <span> {{ 'col1Label' | res : pageId }}</span>
          </div>
        </goab-table-sort-header>
      </th>
      <th>
        <goab-table-sort-header
          [name]="'capacityReportPeriodDueDate'"
          [direction]="sort().capacityReportPeriodDueDate!"
        >
          <div class="header-container">
            <span> {{ 'col2Label' | res : pageId }}</span>
          </div>
        </goab-table-sort-header>
      </th>
      <th>
        <goab-table-sort-header
          [name]="'submittedAt'"
          [direction]="sort().submittedAt!"
        >
          <div class="header-container">
            <span> {{ 'col3Label' | res : pageId }}</span>
          </div>
        </goab-table-sort-header>
      </th>

      <th>{{ 'col4Label' | res : pageId }}</th>
      <th>{{ 'col5Label' | res : pageId }}</th>
    </tr>
  </thead>
  <tbody class="view-entries-table">
    <tr
      *ngFor="let facility of userFacility(); index as i"
      [ngClass]="i % 2 === 0 ? 'even' : 'odd'"
    >
      <td>
        <!--TODO: link to facility details page -->

        <a
          *ngIf="
            !facility.hasEarlierIncompleteReports ||
              facility.status === 'Completed';
            else labelOnly
          "
          routerLink=""
          (click)="onFacilityClick(facility.id)"
        >
          {{ facility.facilityName }}
        </a>
        <ng-template #labelOnly>
          <span class="locked-label">{{ facility.facilityName }}</span>
          <span class="locked-label"
            >Locked: Please submit the previous week's report to unlock this
            report</span
          ></ng-template
        >
      </td>
      <td>
        @if(!facility.hasEarlierIncompleteReports || facility.status ===
        'Completed'){ {{ facility.capacityReportPeriodDueDate | alaDateTransform
        }} } @else {
        <span class="locked-label">
          {{ facility.capacityReportPeriodDueDate | alaDateTransform }}</span
        >
        }
      </td>

      @if(facility.submittedAt && facility?.status === 'Completed' ) {
      <td>{{ facility.submittedAt | alaDateTransform }}</td>
      } @else {
      <td>-</td>
      }

      <td>
        <goab-badge
          data-testid="status-badge"
          [type]="facility.status | badgeTransform"
          content="{{ facility.status | alaEnumReverseMapping }}"
        ></goab-badge>
      </td>
      @if(facility.submittedAt && facility?.status === 'Completed' ) {
      <td>{{ facility.submittedByName }}</td>
      } @else {
      <td>-</td>
      }
      <!-- <td>{{ facility.submittedByName }}</td> -->
    </tr>
  </tbody>
</goab-table>
<app-capacity-reporting-pagination></app-capacity-reporting-pagination>
